/**
* team grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the team grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'team-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      $( '.team-popup' ).magnificPopup( {
        type: 'inline',
        closeBtnInside: true,
        closeOnContentClick: false,
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'team-grid', COMPONENT );
} )( app );
